export default __webpack_public_path__ + "src/img/articles/ne-nado-zdat//slue-sky-desktop.png";